const getShiftStatusAPI = () => 'api/shift/status';

const startShiftAPI = (shiftType, shiftId) => {
  if (shiftId) {
    return `api/shift/start?shiftType=${shiftType}&shiftId=${shiftId}`;
  }
  return `api/shift/start?shiftType=${shiftType}`;
};

const endShiftAPI = (shiftTimeId) => `api/shift/${shiftTimeId}/end`;

const pauseShiftAPI = (shiftTimeId) => `api/shift/${shiftTimeId}/pause`;

const resumeShiftAPI = (shiftTimeId) => `api/shift/${shiftTimeId}/resume`;

const takeBreakAPI = (shiftTimeId, breakID) => `api/shift/${shiftTimeId}/start-break/${breakID}`;

const endBreakAPI = (shiftTimeId, breakTimeId) => `api/shift/${shiftTimeId}/end-break/${breakTimeId}`;

const trackLocationAPI = (shiftTimeId) => `api/shift/${shiftTimeId}/track-location`;

const getShiftMapAPI = (shiftTimeId) => `api/shift/${shiftTimeId}/shift-map`;

const getShiftRepossessionsOverviewAPI = (shiftTimeId) => `api/shift/${shiftTimeId}/repossessions-overview`;

const getShiftRepossessionsGoalsAPI = (shiftId) => `api/shift/repossessions-goals?shiftId=${shiftId}`;

const getShiftRepossessionsHitListAPI = (branchId) => `api/shift/repossessions-hit-list?branchId=${branchId}`;

const getSpottedVehicleByVinAPI = (shiftTimeId, vin) => `api/shift/${shiftTimeId}/spotted-vehicle?vin=${vin}`;

const submitSpottedVehicleAPI = (shiftTimeId) => `api/shift/${shiftTimeId}/spotted-vehicle`;

const getShiftInfractionsAPI = (shiftTimeId) => `api/shift/${shiftTimeId}/infractions`;

const getShiftPendingInfractionsAPI = (shiftTimeId) => `api/shift/${shiftTimeId}/pending-infractions`;

const answerInfractionAPI = (breakId) => `api/shift/infraction-answer/${breakId}`;

export const shiftEndpoints = {
  getShiftStatusAPI,
  startShiftAPI,
  pauseShiftAPI,
  resumeShiftAPI,
  takeBreakAPI,
  endBreakAPI,
  endShiftAPI,
  trackLocationAPI,
  getShiftMapAPI,
  getShiftRepossessionsOverviewAPI,
  getShiftRepossessionsGoalsAPI,
  getShiftRepossessionsHitListAPI,
  getSpottedVehicleByVinAPI,
  submitSpottedVehicleAPI,
  getShiftInfractionsAPI,
  getShiftPendingInfractionsAPI,
  answerInfractionAPI,
};
